import React, { Component } from 'react'

import First from '../block/First'
import KatalogNg from '../block/KatalogNg'
import KatalogTop from '../block/KatalogTop'
import ProductionCapacity from '../block/ProductionCapacity'
import About from '../block/About'
import Trusr from '../block/Trusr'
import Oblast from '../block/Oblast'
import Obekti from '../block/Obekti'
import Feedback from '../block/Feedback'
import News from '../block/News'
import Faq from '../block/Faq'

class App extends Component {

  render() {
    const { data, showWindow } = this.props

    return (
      <>
        <First
          bg={data?.first_bg}
          video="/first_bg.mp4"
          poster="/first_bg_poster.jpg"
          title={data?.first_title}
          text={data?.first_text}
          chipText={data?.first_chipText}
          button1Text={data?.first_button1Text}
          button2Text={data?.first_button2Text}
          scrollText={data?.first_scrollText}
          height={data?.first_height}
          plashka={data?.first_plashka}
          cert
          data={data}
        />
        <KatalogNg data={data} />
        <KatalogTop data={data} />
        <ProductionCapacity data={data} />
        <About data={data} />
        <Trusr data={data} showWindow={showWindow} />
        <Oblast data={data} />
        <Obekti data={data} />
        <Feedback data={data} />
        <News data={data} />
        <Faq data={data} />
      </>
    )
  }
}

export default App